module.exports = __webpack_public_path__ + "static/media/money-square-solid.bac71a7a.svg";